(function(Drupal, $, once) {
  $(function() {
    if ($(".view-acquia-search").length) {
      verifySearchState();
    }
  });

  // Compare the URL and the form parameters.
  // In case they are different, like when the user back from a page,
  // the form is submitted again so the results are accurate.
  const verifySearchState = () => {
    const url = new URL(window.location.href);
    const urlParams = {
      type: url.searchParams.get("type"),
      search: url.searchParams.get("search")
    };

    const $form = $("#views-exposed-form-acquia-search-page");
    const formParams = $form.serializeArray();
    const formType = formParams.find(obj => obj.name === "type");
    const formSearch = formParams.find(obj => obj.name === "search");

    if (
      formType.value != urlParams.type ||
      formSearch.value != urlParams.search
    ) {
      $form.find("#edit-submit-acquia-search").click();
    }
  };

  // Quicksearch component behaviors.
  // Found in the menu, submenu and the search page.
  Drupal.behaviors.quicksearch = {
    attach: function() {
      $(".block-views-exposed-filter-blockacquia-search-page").find('input#edit-type-all').parent().addClass("hidden");
      $(once("quicksearch", ".block-views-exposed-filter-blockacquia-search-page" === document ? 'html' : ".block-views-exposed-filter-blockacquia-search-page")).find("button#edit-submit-acquia-search--2").addClass("quicksearch-submit btn-primary").text("").append('<img class="search-icon" src="/themes/custom/onespan/images/icons/search.svg" width="16" height="16" alt=""/>');
      $(once("quicksearch", ".form-item-search, .form-item-search-api-fulltext, .menu-search-input"))
        .each(function() {
          const $qsItem = $(this);
          const $qsTextInput = $qsItem.find("input.form-text");
          const $qsSubmit = $qsItem.siblings("button.form-submit");
          const $qsWrapper = $('<div class="quicksearch">');
          const $qsParent = $qsItem.parent();
          const $qsForm = $qsItem.parents("form");
          const $submenu = $qsWrapper.closest(".submenu-bar");
          const isQsResultInput =
            $qsItem.parents(".search-page-form").length ||
            $qsItem.parents(".modal").length;

          $qsItem
            .addClass("quicksearch-item")
            .find("label")
            .hide();

          $qsTextInput
            .addClass("quicksearch-input bar")
            .attr("placeholder", Drupal.t("Keyword Search"))
            .attr("tabindex", "-1");

          $qsWrapper
            .append($qsItem)
            .append($qsSubmit)
            .appendTo($qsParent);

          if ($qsTextInput.val() != "" || isQsResultInput) {
            $qsWrapper.addClass("active");
          }

          // If we're not on the search page.
          if (!$qsWrapper.hasClass("active")) {
            // Toggle or submit the quicksearch component.
            $qsSubmit.onFirst("click", e => {
              const isActive = $qsWrapper.hasClass("active");
              const hadValue = $qsWrapper.hasClass("with-value");
              const isEmpty = $qsTextInput.val() == "";
              const doSubmit = isActive && (!isEmpty || hadValue);

              if ($submenu.length) {
                $qsItem.css(
                  "width",
                  isActive ? 44 : $submenu.find(".menu").width()
                );
              }

              $qsWrapper.toggleClass("with-value", !isEmpty);
              toggleOpen(!isActive || !isEmpty);

              if (doSubmit) {
                $qsForm.submit();
              } else {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
              }
            });

            var toggleOpen = Drupal.debounce(function (value) {
              $qsWrapper.toggleClass("active", value);
              $qsTextInput.attr("tabindex", value ? "0" : "-1");

              if (value) {
                $qsSubmit.blur();
                $qsTextInput.focus();
              }
            }, 0, true);

            var mouseUse = false
            // Close the quicksearch component when clicking outside.
            $(document).on("mousedown", e => {
              mouseUse = true;
              const $target = $(e.target);
              const isActive = $qsWrapper.hasClass("active");

              if (!$target.closest(".quicksearch, .quicksearch-submit").length && isActive) {
                $qsWrapper.removeClass("active");
              }
            });

            $(document).on("mouseup", e => {
              mouseUse = false;
            });

            $($qsSubmit, $qsTextInput).on('focus', function (e) {
              const isActive = $qsWrapper.hasClass("active");
              if (!mouseUse && !isActive)
                toggleOpen(true);
            });
            $($qsSubmit).on('blur', function (e) {
              if (!mouseUse)
                toggleOpen(false);
            });
          }

          $qsItem.closest(".hidden").removeClass("hidden");
        });
    }
  };

  // Add the dropdown on the Search page for mobile.
  Drupal.behaviors.searchMobileDropdown = {
    attach: function() {
      const $searchForm = $(".search-page-form");
      $(once("searchMobileDropdown", $searchForm)).each(function () {
        const $searchDropdown = $searchForm.find(".dropdown");
        $searchForm.removeClass("hidden");
        $searchForm
          .find('fieldset[data-drupal-selector="edit-type"] label')
          .each(function (index, elem) {
            const text = $(elem).text();
            const active = $(elem)
              .prev()
              .is(":checked")
              ? "active"
              : "";
            const $dropdownItem = $(
              '<li class="' + active + '">' + text + "</li>"
            );
            $searchDropdown.find("ul").append($dropdownItem);

            if ($(elem).prev().is(":checked")) {
              $searchDropdown.find(".title").text(text);
            }

            $dropdownItem.on("click", function () {
              $searchDropdown.find(".title").text(text);
              $searchForm.find('fieldset[data-drupal-selector="edit-type"] input[data-drupal-selector="edit-type-' + (index + 1) + '"]').next().trigger("click");
              $searchDropdown.find("li.active").removeClass("active");
              $(this).toggleClass("active");
            });
          });
      });
    }
  };
})(Drupal, jQuery, once);
